import React from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import HowToPlayContent from "@/components/HowToPlayContent";
import { GraduationCap, ArrowRight } from "@phosphor-icons/react";

export default function HowToPlay() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen" data-testid="how-to-play-page">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-10 md:py-16">
        <p className="text-xs uppercase tracking-[0.25em] font-bold text-muted-foreground mb-3">
          Help
        </p>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight mb-3">
          How to play <span className="text-brand">Jangle</span>
        </h1>
        <p className="text-base text-muted-foreground mb-8 max-w-prose">
          A two-minute video, then the full rules with pictures: tiles, squares, POW cards, awards and the boards.
        </p>
        {user && (
          <Link
            to="/welcome?step=game"
            className="mb-12 flex items-center gap-4 p-4 rounded-2xl border border-brand/40 bg-brand/5 hover:bg-brand/10 transition-colors"
            data-testid="replay-tutorial"
          >
            <GraduationCap size={32} weight="duotone" className="text-brand flex-none" />
            <div className="min-w-0 flex-1">
              <div className="font-display font-bold">Play the demo game again</div>
              <div className="text-sm text-muted-foreground">A guided game against Rookie Rufus on the Classic board, pointing out each part of the board.</div>
            </div>
            <ArrowRight size={18} weight="bold" className="text-brand flex-none" />
          </Link>
        )}
        <HowToPlayContent />
      </div>
    </div>
  );
}
